import React from "react";
import { passwordStrength } from "@/lib/vaultCrypto";
import { cn } from "@/lib/utils";

const COLORS = ["bg-[#B42318]", "bg-[#B42318]", "bg-[#8A5A00]", "bg-[#1E7A3A]", "bg-primary"];

export const StrengthMeter = ({ password, className, testId = "strength-meter", showLabel = true }) => {
  const s = passwordStrength(password);
  const filled = password ? Math.max(1, s.score) : 0;
  return (
    <div className={cn("space-y-1", className)} data-testid={testId} aria-live="polite">
      <div className="grid grid-cols-4 gap-1" role="meter" aria-valuemin={0} aria-valuemax={4} aria-valuenow={s.score} aria-label="Passordstyrke">
        {[0, 1, 2, 3].map((i) => <span key={i} className={cn("h-1.5 rounded-full transition-colors", i < filled ? COLORS[s.score] : "bg-border")} />)}
      </div>
      {showLabel ? <p className="text-xs text-muted-foreground">{password ? <>{s.label} <span className="tnum">· {s.bits} bit</span></> : "Skriv et passord for å se styrke"}</p> : null}
    </div>
  );
};
